export default {
  props: {
    rowCol: {
      type: Number,
      default: 4
    },
    itemList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeKey: 0
    };
  },
  computed: {
    textStyle() {
      const style = {
        left: '0px'
      };
      const keyValue = this.activeKey + 1;
      // 根据设计稿一行4项/3项，计算向左偏移位置
      if (this.rowCol === 4) {
        if (keyValue % 4 === 0) {
          style.left = `${-317 * 3 - 12}px`;
        } else if (keyValue % 2 === 0) {
          style.left = `${-317 - 4}px`;
        } else if (keyValue % 4 % 3 === 0) {
          style.left = `${-317 * 2 - 8}px`;
        } else {
          style.left = '0px';
        }
      } else {
        if (keyValue % 3 === 0) {
          style.left = `${-424 * 2 - 8}px`;
        } else if (keyValue % 3 === 1) {
          style.left = '0px';
        } else {
          style.left = `${-424 - 4}px`;
        }
      }
      return style;
    }
  }
};